{
  "alert": "Įspėjimas",
  "dismiss": "Atmesti"
}
